import React, {Fragment} from 'react';
import {
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@material-ui/core";
import CustomInput from "components/CustomInput/CustomInput.jsx";


const MobileNumberPanel = ({ user, handleSelect, airports, airportCode2, classes, additionalMobileNumbers, activeEditMobileNumber, editedMobileNumbers, handleChange, handleChangeMobileNumber, handleActiveInput }) => {
    return (
        <div>
            <Grid item md={12} sm={12}>
                <TextField
                    className={classes.wide}
                    multiline
                    rowsMax="10"
                    id="additionalNumbers"
                    label="Additional Number(s)"
                    name="additionalMobileNumbers"
                    value={additionalMobileNumbers}
                    onChange={handleChange}
                    margin="normal"
                    variant="outlined"
                />
                <div className={classes.nb}>*separate multiple numbers with comma</div>
                {
                    editedMobileNumbers && editedMobileNumbers.map((emails,i)=>(
                    <Fragment key = {i}>
                        <Grid item md={10} sm={7}>
                            <CustomInput
                                labelText="Exisiting Mobile Number"
                                id="exisitingMobileNumber"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={
                                    {
                                        disabled: !(activeEditMobileNumber === i),
                                        value: editedMobileNumbers[i],
                                        name: "mobileNumbers",
                                        type: "text",
                                        onChange: (event) => handleChangeMobileNumber(event, i),
                                    }}
                            />
                        </Grid>
                        <Grid item md={2} sm={2} className={classes.edit}>
                            <div onClick={()=> handleActiveInput(emails,i, 2)} style={{color:"#dd2735",cursor:"pointer", margin:"0 0 10px 10px"}} autoFocus>
                                Edit
                            </div>
                        </Grid>
                    </Fragment>
                    ))
                }
            </Grid>

            <Grid item md={12} sm={12}>
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Airports</InputLabel>
                    <Select
                        disabled= {user.AppRole === "Manager" ? false : true}
                        value={airportCode2}
                        onChange={(event)=>handleSelect(event)}
                        formcontrolprops={{
                            fullWidth: true
                        }}
                        inputProps={{
                            name: 'airportCode2',
                            id: 'airportCode2',
                        }}
                    >
                        <MenuItem value="Placeholder">Select Airport</MenuItem>
                        {airports.map((option, i) => (
                            <MenuItem
                                key={i}
                                value={option.Code}
                                className={classes.select}
                            >
                                {option.Name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

        </div>
    );
};

export default MobileNumberPanel;



// WEBPACK FOOTER //
// ./src/Regional-Views/EmailSettings/MobileNumberPanel.js